import { Dialog, DialogContent, DialogTitle } from '../ui/dialog';
import ProfileTabAccountInfoCodes from '../ProfileTabAccountInfoCodes';
import { useState } from 'react';
import { Button } from '../ui/button';
import { XIcon } from 'lucide-react';

export default function PromoCodeSelectionDialog({
  open,
  onOpenChange,
  onCodeClick,
  closeDialog,
  stacked,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  closeDialog: () => void;
  onCodeClick?: (code: string) => void;
  stacked?: boolean;
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogTitle className="hidden" />
      <DialogContent
        overlayClassName={stacked ? 'z-[100]' : undefined}
        className={
          stacked
            ? 'z-[100] max-h-[70vh] w-[min(92vw,360px)] max-w-[360px] overflow-y-auto rounded-3xl p-4 sm:w-full sm:max-w-[800px]'
            : 'sm:max-w-[800px]'
        }
        onInteractOutside={closeDialog}
        aria-describedby=""
      >
        <Button variant="ghost" className="absolute top-5 right-2" onClick={closeDialog}>
          <XIcon className="size-4" />
        </Button>
        <ProfileTabAccountInfoCodes onCodeClick={onCodeClick} />
      </DialogContent>
    </Dialog>
  );
}
